var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { SelectorIcon, XIcon } from '../icons/index.js';
import { useFloatingContext } from '../utils/floating/index.js';
import { useSearchableSelect } from './SearchableSelectContext.js';
export const SearchableSelectButton = forwardRef((props, ref) => {
    const { children, className, placeholder, dense = false } = props, rest = __rest(props, ["children", "className", "placeholder", "dense"]);
    const { inputValue, disabled, getComboboxProps, getInputProps, getToggleButtonProps, selectedItem, reset, } = useSearchableSelect();
    const { reference } = useFloatingContext();
    const clearButton = (React.createElement("button", { type: "button", className: "absolute inset-y-0 right-0 flex items-center px-2 rounded-md", "aria-label": "clear selection", onClick: e => {
            e.stopPropagation();
            reset();
        } },
        React.createElement(XIcon, { className: "w-5 h-5 text-basicSurface-400", "aria-hidden": "true" })));
    const toggleButton = (React.createElement("span", { className: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none", "aria-label": "toggle menu" },
        React.createElement(SelectorIcon, { className: "w-5 h-5 text-basicSurface-400", "aria-hidden": "true" })));
    const onKeyDown = event => {
        if (event.key === 'Backspace' && !inputValue) {
            reset();
        }
    };
    return (React.createElement("div", { ref: reference },
        React.createElement("div", Object.assign({ className: clsx('block w-full rounded-md group relative', 'bg-surface-50 text-basicSurface-500', 'py-2 text-left cursor-default', !dense && ' border border-basicSurface-300/25 pl-3 pr-10', !disabled &&
                'focus:outline-none focus-visible:ring focus-within:ring-actionPrimary-500 focus-within:border-actionPrimary-500', disabled && 'opacity-60 cursor-default', className) }, getComboboxProps(getToggleButtonProps(Object.assign({ disabled, ref }, rest)))),
            React.createElement("span", { className: "block truncate" },
                React.createElement("div", { className: "flex space-x-2" },
                    selectedItem && !inputValue && (React.createElement("div", { className: "flex-shrink-0" }, children)),
                    React.createElement("input", Object.assign({ className: clsx('placeholder-basicSurface-300/75 focus:outline-none bg-transparent flex-1 overflow-hidden') }, getInputProps({
                        placeholder: selectedItem ? '' : placeholder,
                        disabled,
                        onKeyDown,
                    }))))),
            !dense && (selectedItem ? clearButton : toggleButton))));
});
//# sourceMappingURL=SearchableSelectButton.js.map